<template>
  <v-btn
    :height="height"
    depressed
    class="primary"
    @click="$emit('click')"
    v-bind="$attrs"
  >
    <slot></slot>
  </v-btn>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    height: {
      type: String,
      default: "40px",
    },
  },
};
</script>

<style></style>
